import React, { useState, createContext } from 'react'
import axios from 'axios'

export const QuizContext = createContext()

export const QuizProvider = (props) => {

	const [curQuestion, setCurQuestion] = useState(0)
	const [maxQuestions, setMaxQuestions] = useState(10)
	const [questions, setQuestions] = useState({})
	const [answer, setAnswer] = useState('')
	const [score, setScore] = useState(0)

	const getQuestions = () => {
		let quizapi = 'https://opentdb.com/api.php?amount=10&difficulty=easy&type=multiple'

		axios.get( quizapi )
		.then( res => 
			setQuestions(
				res.data.results.map( question => ({
					...question, answers: ([...question.incorrect_answers, question.correct_answer]).sort( () => .5 - Math.random() )
				}))
			)
		)

	}

	let returnList = {
		curQuestion, setCurQuestion, maxQuestions, setMaxQuestions,
		questions, setQuestions, score, setScore, answer, setAnswer,
		getQuestions
	}

	return (
		<QuizContext.Provider value={returnList}>
			{props.children}
		</QuizContext.Provider>
	)
}
